import React from 'react';
import { Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ContactInfo = () => {
  const { t } = useTranslation();
  
  return (
    <Box sx={{ bgcolor: "#f5f5f5", p: 3, borderRadius: 1 }}>
      <Typography variant="subtitle1" fontWeight="bold">
        {t('privacy-policy.personal-data-notice.contact_info.title')}
      </Typography>
      <Typography>
        {t('privacy-policy.personal-data-notice.contact_info.department')}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
        <i className="fas fa-building"></i>
        <Typography sx={{ ml: 1 }}>
          {t('privacy-policy.personal-data-notice.contact_info.address')}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
        <i className="fas fa-phone"></i>
        <Typography sx={{ ml: 1 }}>
          {t('privacy-policy.personal-data-notice.contact_info.phone')}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
        <i className="fas fa-envelope"></i>
        <Typography sx={{ ml: 1 }}>
          {t('privacy-policy.personal-data-notice.contact_info.email')}
        </Typography>
      </Box>
    </Box>
  );
};

export default ContactInfo;